import { XCircle } from "lucide-react";

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: (() => void) | undefined;
  retryLabel?: string;
}

export function ErrorState({ title = "Erro ao carregar", message, onRetry, retryLabel = "Tentar novamente" }: ErrorStateProps) {
  return (
    <div className="error-state" role="alert">
      <span className="error-icon" aria-hidden="true">
        <XCircle size={48} />
      </span>
      <h2 className="error-title">{title}</h2>
      <p className="error-message">{message}</p>
      {onRetry && (
        <button type="button" className="primary big-button" onClick={onRetry}>
          {retryLabel}
        </button>
      )}
    </div>
  );
}
